import { TableRow, TableCell } from "@/components/ui/table";
import { flexRender, Row } from "@tanstack/react-table";

export default function MobilizationTableRow<Tdata>({
    row,
}: {
    row: Row<Tdata>;
    i: number;
}) {
    const de_mob_date = (
        row.original as {
            de_mobilized_date: string;
        }
    ).de_mobilized_date
        ? new Date(
              (
                  row.original as {
                      de_mobilized_date: string;
                  }
              ).de_mobilized_date,
          )
        : null;

    const mob_date = new Date(
        (
            row.original as {
                mobilized_date: string;
            }
        ).mobilized_date,
    );
    const currentDate = new Date();

    const isMob = !de_mob_date
        ? mob_date < currentDate
        : de_mob_date > currentDate;

    return (
        <TableRow
            key={row.id}
            data-state={row.getIsSelected() && "selected"}
            className={` ${isMob ? "text-black" : "text-red-600"} even:bg-gray-100 hover:bg-slate-100`}
        >
            {row.getVisibleCells().map((cell) => {
                return (
                    <TableCell key={cell.id}>
                        <div className="h-full w-full">
                            {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext(),
                            )}
                        </div>
                    </TableCell>
                );
            })}
        </TableRow>
    );
}
